var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent"}},[_c('TopSection'),_c('AboutSection'),_c('VerticalCarrouselSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }